// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_better_auth_invalid_prefix_length19 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The prefix length is either too large or too small.`)
};

const en_us2_better_auth_invalid_prefix_length19 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The prefix length is either too large or too small.`)
};

const de_de2_better_auth_invalid_prefix_length19 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Präfixlänge ist entweder zu groß oder zu klein.`)
};

const en_better_auth_invalid_prefix_length19 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The prefix length is either too large or too small.`)
};

const de_better_auth_invalid_prefix_length19 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Präfixlänge ist entweder zu groß oder zu klein.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const better_auth_invalid_prefix_length19 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.better_auth_invalid_prefix_length19(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("better_auth_invalid_prefix_length19", locale)
	if (locale === "en-GB") return en_gb2_better_auth_invalid_prefix_length19(inputs)
	if (locale === "en-US") return en_us2_better_auth_invalid_prefix_length19(inputs)
	if (locale === "de-DE") return de_de2_better_auth_invalid_prefix_length19(inputs)
	if (locale === "en") return en_better_auth_invalid_prefix_length19(inputs)
	return de_better_auth_invalid_prefix_length19(inputs)
};
export { better_auth_invalid_prefix_length19 as "better-auth.INVALID_PREFIX_LENGTH" }